function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/* ----------------------------------------------------------------
Import XML Feed Script
---------------------------------------------------------------- */

import '../../../../../xmlfeed/scripts/';

/* ----------------------------------------------------------------
Import Scripts
---------------------------------------------------------------- */

import VideoEmbed from '../classes/video';
import SimpleSelector from 'simple-selector';

/* ----------------------------------------------------------------
Custom XML Feed Scripts
---------------------------------------------------------------- */

document.addEventListener('DOMContentLoaded', function () {
  if (window.XMLFeed) {
    // We will use this for timeouts
    var time = {};
    // We will use some timeouts
    var timeouts = {};
    // The content that will hold the XML feed
    var content = document.querySelector('.xml-feed__list');
    // grab all the select elements
    var selects = document.querySelectorAll('.xml-feed__filters select');

    // Loop through the selects and set up new SimpleSelectors and add a custom 'input' event
    var _loop = function _loop() {
      // The element
      var select = selects[index];

      // Create a new SimpleSelector
      new SimpleSelector(select);

      // We will use this to create a custom 'input' event for the select element when the selector is updated
      var event = null;
      try {
        // This will be used to trigger a change event on the real select element
        event = new Event('input');
      } catch (err) {
        event = document.createEvent('CustomEvent');
        event.initCustomEvent('input', false, false, undefined);
        event = event;
      }

      // When the select is changed dispatch a new input event
      select.addEventListener('change', function () {
        return select.dispatchEvent(event);
      });
    };
    for (var index = 0; index < selects.length; index++) {
      _loop();
    }

    // When we set a filter, we will add a class and update the set time
    window.XMLFeed.on('change', function () {
      content.classList.add('is-loading');
      // Set the set time
      time['set'] = new Date().getTime();
    });
    window.XMLFeed.on('filter', function (response) {
      // Clear the exisiting timeout if there is one
      clearTimeout(timeouts['filter']);
      // Update the filter time
      time['filter'] = new Date().getTime();
      // Set the delay - this will make sure we wait for at least 500ms to allow for smooth animations
      time['delay'] = 500 - (time['filter'] - time['set']);
      // If the time difference is greater than 500ms
      timeouts['filter'] = setTimeout(function () {
        return content.classList.remove('is-loading');
      }, time['delay']);

      // Set up the videos if there are any
      _toConsumableArray(content.querySelectorAll('[data-video]')).forEach(function (video) {
        var embed = new VideoEmbed(video.getAttribute('data-video'));
        video.addEventListener('click', function (e) {
          e.preventDefault();
          video.innerHTML = embed.render();
        });
      });
    });
  }
});